@if (showLauncher()) {
  <div id="onboarding-launcher" class="launcher fixed bottom-4 right-4 z-[1100] flex items-center gap-1">
    @if (collapsed()) {
      <button
        id="onboarding-launcher-button"
        #launcherButton
        type="button"
        class="launcher-round relative inline-flex items-center justify-center rounded-full"
        [attr.aria-label]="'onboarding.launcher.open_collapsed' | translate: progressParams()"
        [appTippy]="'onboarding.launcher.open_collapsed' | translate: progressParams()"
        [tippyOptions]="{ placement: 'left' }"
        (click)="openPanel()"
      >
        <mat-icon aria-hidden="true">{{ store.celebrating() ? 'emoji_events' : 'school' }}</mat-icon>
        @if (store.pendingRequired() > 0) {
          <span class="launcher-badge absolute -right-1 -top-1 inline-flex items-center justify-center rounded-full" aria-hidden="true">
            {{ store.pendingRequired() }}
          </span>
        }
      </button>
      <button
        id="onboarding-launcher-expand-button"
        type="button"
        class="launcher-toggle inline-flex items-center justify-center rounded-full"
        [attr.aria-label]="'onboarding.launcher.expand' | translate"
        (click)="toggleCollapsed()"
      >
        <mat-icon aria-hidden="true">chevron_left</mat-icon>
      </button>
    } @else {
      <button
        id="onboarding-launcher-button"
        #launcherButton
        type="button"
        class="launcher-pill flex items-center gap-3 rounded-full py-2 pl-2 pr-4"
        (click)="openPanel()"
      >
        <span class="ring relative inline-flex shrink-0 items-center justify-center" aria-hidden="true">
          <svg viewBox="0 0 40 40" class="ring-svg absolute inset-0 -rotate-90">
            <circle class="ring-track" cx="20" cy="20" r="16" fill="none" stroke-width="4"></circle>
            <circle
              class="ring-fill"
              cx="20"
              cy="20"
              r="16"
              fill="none"
              stroke-width="4"
              stroke-linecap="round"
              [attr.stroke-dasharray]="ringDash()"
            ></circle>
          </svg>
          <mat-icon class="ring-icon">{{ store.celebrating() ? 'emoji_events' : 'school' }}</mat-icon>
        </span>
        <span class="flex flex-col items-start">
          <span class="launcher-title">{{ 'onboarding.panel.kicker' | translate }}</span>
          <span class="launcher-meta">
            @if (store.celebrating()) {
              {{ 'onboarding.launcher.completed' | translate }}
            } @else {
              {{ metaKey() | translate: metaParams() }}
            }
          </span>
        </span>
      </button>
      <button
        id="onboarding-launcher-collapse-button"
        type="button"
        class="launcher-toggle inline-flex items-center justify-center rounded-full"
        [attr.aria-label]="'onboarding.launcher.collapse' | translate"
        (click)="toggleCollapsed()"
      >
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      </button>
    }
  </div>
}

@if (store.panelOpen()) {
  <app-onboarding-panel (closed)="onPanelClosed()" />
}

@defer (when runner.hasActiveTutorial()) {
  <app-onboarding-tutorial-host />
}
